const MILLISECONDS_IN_A_MONTH = 1000 * 60 * 60 * 24 * 30;
const MILLISECONDS_IN_A_YEAR = 1000 * 60 * 60 * 24 * 365.25;

export const years = (pastDate: Date) => {
	const old = () => {
		const currentDate = new Date();

		const yearsBetween = (Number(currentDate) - Number(pastDate)) / MILLISECONDS_IN_A_YEAR;

		const yearsOld = Math.floor(yearsBetween);

		return yearsOld;
	};

	return { old };
};

export const months = (pastDate: Date) => {
	const old = () => {
		const currentDate = new Date();

		const monthsBetween = (Number(currentDate) - Number(pastDate)) / MILLISECONDS_IN_A_MONTH;

		const monthsOld = Math.floor(monthsBetween);

		return monthsOld;
	};

	return { old };
};
